import { css } from 'emotion';

export const drawer = css`
  z-index: 2147483001 !important;
  width: 100vw !important;
  height: 100% !important;
  padding: 0 !important;
  padding-bottom: 10px !important;
`;
